import _ from 'lodash';
import VersionCommentContent from '../../../components/Prompt/Content/VersionCommentContent';
import AffectedPpsisContent from './AffectedPpsisContent';

const steps = [
  {
    label: 'ppi.publishAffectedPpsisLabel',
    Content: AffectedPpsisContent,
    visible: (ppi, affectedPpsis) => {
      return affectedPpsis.size > 0;
    },
    validate: () => true
  },
  {
    label: 'ppi.approvalVersionCommentLabel',
    Content: VersionCommentContent,
    visible: ppi => {
      return ppi.version > 1;
    },
    validate: ({ state, setState, languages }) => {
      let versionCommentHasError = false;
      if (state.isUpdate) {
        languages.forEach(({ code }) => {
          if (!_.get(state, `versionComment.${code}`)) {
            versionCommentHasError = true;
          }
        });
      }
      setState({ versionCommentHasError });
      return !versionCommentHasError;
    }
  }
];

const getPublishSteps = (ppi, affectedPpsis) => {
  return steps.filter(step => step.visible(ppi, affectedPpsis));
};

export default getPublishSteps;
